import { deepPurple, lightBlue } from "../../../mp-core/themes/palette"

export enum NoDataType {
  NO_DATA = "no-data",
  NO_DATA_BY_FILTERS = "no-data-by-filters",
  NO_DATA_BY_SEARCH = "no-data-by-search"
}

export const EMPTY_MESSAGE_DATA_BY_TYPE = {
  [NoDataType.NO_DATA]: {
    title: "No Records Available",
    text: "There’s currently no data to display. Once records are added, they’ll appear here.",
    icon: "circle-dashed",
    iconColor: lightBlue[700],
    iconBgColor: lightBlue[100]
  },
  [NoDataType.NO_DATA_BY_FILTERS]: {
    title: "No Results Found",
    text: "Your filters returned no results. Adjust them to see more data.",
    icon: "filter",
    iconColor: deepPurple[700],
    iconBgColor: deepPurple[100]
  },
  [NoDataType.NO_DATA_BY_SEARCH]: {
    title: "No Results Found",
    text: "Your search inquiry returned no results. Adjust it to see more data. ",
    icon: "search",
    iconColor: lightBlue[700],
    iconBgColor: lightBlue[100]
  }
}
